import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '@iconify/react';

export default function ERPDashboard() {


  return (
    <div dir="rtl" className="flex w-full h-full bg-bg-primary  text-text-primary overflow-hidden transition-colors duration-300">
       {/* --- MAIN CONTENT AREA --- */}
      <main className="flex-1 flex flex-col h-full justify-center  overflow-hidden">

        {/* DASHBOARD CONTENT */}
        <div className="flex-1  overflow-y-auto py-2 px-4 lg:px-8">
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
            className=""
          >
            <h2 className="text-xl sm:text-2xl font-black text-text-primary mb-1">نظرة عامة</h2>
            <p className="text-xs sm:text-sm text-text-secondary">إحصائيات مالية وتشغيلية مباشرة من قاعدة البيانات</p>
          </motion.div>

          {/* KPI CARDS */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 mb-6 sm:mb-8">
            <KPICard title="إجمالي الإيرادات" value="24,500,000" trend="+12.5%" trendUp={true} icon="solar:wad-of-money-bold-duotone" color="from-emerald-500 to-teal-400" delay={0.1}/>
            <KPICard title="قيمة المخزون" value="18,230,000" trend="-2.4%" trendUp={false} icon="solar:box-minimalistic-bold-duotone" color="from-blue-500 to-indigo-500" delay={0.2}/>
            <KPICard title="تراخيص DRM" value="1,248" trend="+18.2%" trendUp={true} icon="solar:play-stream-bold-duotone" color="from-purple-500 to-fuchsia-500" delay={0.3}/>
            <KPICard title="عمليات معلقة" value="12" trend="مراجعة" trendUp={false} icon="solar:danger-triangle-bold-duotone" color="from-orange-500 to-red-500" delay={0.4}/>
          </div>

          {/* RECENT ACTIVITY & CHART AREA */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6">
            
            {/* Mock Chart Area */}
            <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5, delay: 0.5 }} className="lg:col-span-2 bg-bg-secondary rounded-2xl sm:rounded-3xl p-4 sm:p-6 shadow-sm border border-border">
              <div className="flex items-center justify-between mb-4 sm:mb-6">
                <h3 className="text-base sm:text-lg font-bold text-text-primary">حركة المبيعات</h3>
                <button className="text-xs sm:text-sm font-bold text-brand-primary bg-brand-light px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg hover:opacity-80 transition">تقرير مفصل</button>
              </div>
              <div className="h-40 sm:h-64 flex items-end justify-between gap-1 sm:gap-2 pt-2 sm:pt-4 border-b border-border pb-2 sm:pb-4">
                {[40, 70, 45, 90, 65, 85, 100].map((height, i) => (
                  <div key={i} className="w-full bg-bg-tertiary rounded-t-md sm:rounded-t-lg relative group h-full flex items-end">
                    <motion.div initial={{ height: 0 }} animate={{ height: `${height}%` }} transition={{ duration: 1, delay: 0.5 + (i * 0.1) }} className="w-full bg-gradient-to-t from-indigo-600 to-indigo-400 rounded-t-md sm:rounded-t-lg group-hover:from-indigo-500 group-hover:to-indigo-300 transition-colors"/>
                  </div>
                ))}
              </div>
              <div className="flex justify-between mt-2 text-[10px] sm:text-xs text-text-secondary font-bold px-1">
                <span>سبت</span><span>أحد</span><span>إثنين</span><span>ثلاثاء</span><span>أربعاء</span><span>خميس</span><span>جمعة</span>
              </div>
            </motion.div>

            {/* Recent Transactions */}
            <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5, delay: 0.6 }} className="bg-bg-secondary rounded-2xl sm:rounded-3xl p-4 sm:p-6 shadow-sm border border-border flex flex-col">
              <h3 className="text-base sm:text-lg font-bold text-text-primary mb-4 sm:mb-6">أحدث القيود</h3>
              <div className="flex-1 space-y-3 sm:space-y-4">
                <TransactionRow title="فاتورة #4029" desc="باقة متقدمة" amount="+ 45K" type="positive" iconColor="text-emerald-500" bgColor="bg-emerald-500/10" />
                <TransactionRow title="نقل مخزني" desc="مستودع صنعاء" amount="12 وحدة" type="neutral" iconColor="text-blue-500" bgColor="bg-blue-500/10" />
                <TransactionRow title="سداد مورد" desc="التقنية الحديثة" amount="- 120K" type="negative" iconColor="text-red-500" bgColor="bg-red-500/10" />
                <TransactionRow title="تشفير فيديو" desc="معالجة Widevine" amount="ناجح" type="positive" iconColor="text-purple-500" bgColor="bg-purple-500/10" />
              </div>
              <button className="w-full mt-4 py-2 sm:py-3 rounded-xl border border-border text-xs sm:text-sm font-bold text-text-secondary hover:bg-bg-tertiary hover:text-text-primary transition">
                عرض كل العمليات
              </button>
            </motion.div>

          </div>
        </div>
      </main>
    </div>
  );
}

// KPI CARD
function KPICard({ title, value, trend, trendUp, icon, color, delay }) {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay }}
      whileHover={{ y: -5, scale: 1.02 }}
      className="bg-bg-secondary rounded-2xl sm:rounded-3xl p-3 sm:p-6 shadow-sm border border-border flex flex-col justify-between relative overflow-hidden"
    >
      <div className={`absolute -right-4 -top-4 w-16 h-16 sm:w-24 sm:h-24 bg-gradient-to-br ${color} opacity-10 rounded-full blur-xl sm:blur-2xl`} />
      
      <div className="flex flex-wrap sm:flex-nowrap justify-between items-start gap-2 mb-3 sm:mb-4">
        <div className={`p-2 sm:p-3 rounded-xl sm:rounded-2xl bg-gradient-to-br ${color} text-white shadow-md sm:shadow-lg shrink-0`}>
          <Icon icon={icon} className="text-lg sm:text-2xl" />
        </div>
        <div className={`px-1.5 py-0.5 sm:px-2.5 sm:py-1 rounded-md sm:rounded-lg text-[10px] sm:text-xs font-bold whitespace-nowrap ${trendUp ? 'text-status-success bg-status-success/10' : 'text-status-danger bg-status-danger/10'}`}>
          {trend}
        </div>
      </div>
      
      <div>
        <h4 className="text-text-secondary text-[10px] sm:text-sm font-bold mb-0.5 sm:mb-1 truncate">{title}</h4>
        <p className="text-sm sm:text-2xl font-black text-text-primary truncate" title={value}>{value}</p>
      </div>
    </motion.div>
  );
}

// Transaction Row
function TransactionRow({ title, desc, amount, type, iconColor, bgColor }) {
  return (
    <div className="flex items-center justify-between p-2 sm:p-3 rounded-xl sm:rounded-2xl hover:bg-bg-tertiary transition cursor-pointer">
      <div className="flex items-center gap-2 sm:gap-3">
        <div className={`w-8 h-8 sm:w-10 sm:h-10 shrink-0 rounded-lg sm:rounded-xl flex items-center justify-center ${bgColor} ${iconColor}`}>
          <Icon icon="solar:document-text-bold-duotone" className="text-base sm:text-xl" />
        </div>
        <div className="overflow-hidden">
          <p className="text-xs sm:text-sm font-bold text-text-primary truncate">{title}</p>
          <p className="text-[10px] sm:text-xs text-text-secondary truncate">{desc}</p>
        </div>
      </div>
      <div className={`text-xs sm:text-sm font-black whitespace-nowrap ${type === 'negative' ? 'text-text-primary' : iconColor}`}>
        {amount}
      </div>
    </div>
  );
}